import { useEffect, useState } from "react";
import { ChevronDown, Globe } from "lucide-react";

const LANGS = [["es", "Español"], ["en", "English"], ["fr", "Français"], ["de", "Deutsch"], ["pt", "Português"], ["it", "Italiano"]];

const current = () => (document.cookie.match(/(?:^|;\s*)googtrans=\/es\/([a-z]{2})/) || [])[1] || "es";

const setCookie = (lang) => {
  const host = window.location.hostname;
  const domains = ["", host, `.${host.split(".").slice(-2).join(".")}`];
  domains.forEach((d, i) => {
    const dom = d ? `; domain=${d}` : "";
    if (lang === "es") document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${dom}`;
    else if (i < 2) document.cookie = `googtrans=/es/${lang}; path=/${dom}`;
  });
};

export const LangSwitch = () => {
  const [lang] = useState(current);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  useEffect(() => {
    if (lang === "es" || document.getElementById("gt-script")) return;
    window.googleTranslateElementInit = () => new window.google.translate.TranslateElement({ pageLanguage: "es", includedLanguages: "en,fr,de,pt,it", autoDisplay: false }, "google_translate_element");
    const s = document.createElement("script");
    s.id = "gt-script";
    s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(s);
  }, [lang]);
  const change = (e) => { setCookie(e.target.value); window.location.reload(); };
  return (
    <label className="relative inline-flex items-center gap-1.5 text-white shrink-0 notranslate border border-white/40 hover:border-white rounded-full pl-2.5 pr-2 py-1 cursor-pointer" translate="no" data-testid="lang-switch">
      <Globe size={15} />
      <select value={lang} onChange={change} aria-label="Idioma / Language" className="field-bare appearance-none bg-transparent font-bold text-xs uppercase cursor-pointer outline-none pr-3 [&>option]:text-[#0B1D3A]" data-testid="lang-select">
        {LANGS.map(([k, l]) => <option key={k} value={k}>{k === lang ? `${k.toUpperCase()} · Idioma` : `${k.toUpperCase()} · ${l}`}</option>)}
      </select>
      <ChevronDown size={13} className="absolute right-2 pointer-events-none" />
      <div id="google_translate_element" className="hidden" />
    </label>
  );
};
